/**
 * The financier's money, received against each loan (owner, 27 Oct 2026: "add a feature in surbhi
 * she will add the utr number, amount, date on the payment recieved by the financer against the
 * loan amount it will show pending what all vehicles are remaing whose money hasnt come from the
 * financer").
 *
 * One bank credit (a UTR) can pay one vehicle or many ("for some financer it comes in bulk and for
 * some it comes vehicle wise"), so a payment is split over the vehicles it pays. A financed sale
 * from 1 Sep 2026 is pending until what has come in reaches its loan.
 */
import { HEAD_ADMIN_DESK_EMAILS, ORG_IDS } from './domain.js';

/** Sales from this IST day on are followed (owner, 27 Oct 2026: "Sold from 1 Sep 2026"). */
export const FINANCE_RECEIPTS_FROM = '2026-09-01';

/**
 * Who records the financier's money, book by book. Bright on Wheels is Surbhi's; TVS is to be
 * named ("for tvs somebody else will do it i will tell you afterwards"). The owner's desks keep
 * every book's.
 */
export const FINANCE_RECEIPT_KEEPERS: Readonly<Record<string, readonly string[]>> = {
  [ORG_IDS.bow]: ['surbhi@brightonwheels.in'],
  // FAB EV's head keeps its own (29 Oct 2026: "everything operates under him").
  [ORG_IDS.fabev]: ['sherryfabev@fabev.in'],
};

export function keepsFinanceReceipts(user: { email: string } | null | undefined, organizationId: string | null | undefined): boolean {
  if (!user || !organizationId) return false;
  const email = user.email.trim().toLowerCase();
  if ((HEAD_ADMIN_DESK_EMAILS as readonly string[]).includes(email)) return Boolean(FINANCE_RECEIPT_KEEPERS[organizationId]);
  return (FINANCE_RECEIPT_KEEPERS[organizationId] ?? []).includes(email);
}

/** The books a person keeps the financier's money in — for the menu, whichever book is open. */
export function financeReceiptBooks(user: { email: string } | null | undefined): string[] {
  return Object.keys(FINANCE_RECEIPT_KEEPERS).filter((org) => keepsFinanceReceipts(user, org));
}

export interface FinancePendingRow {
  vehicleId: string;
  chassisNo: string;
  model: string;
  customerName: string | null;
  soldBy: string | null;
  financierId: string | null;
  financier: string | null;
  /** One key per financier, the same in the rows and in `byFinancier`. */
  financierKey: string;
  loanAmount: number;
  /** Kept by the financier, so never received (27 Oct 2026). */
  fileCharge: number;
  /** What the financier pays: the loan less the file charge. */
  expected: number;
  received: number;
  /** Closed as kept by the financier (its fee) — counted as settled, never as received. */
  shortfall: number;
  remaining: number;
  soldAt: string | null;
  daysSinceSale: number | null;
}

export interface FinancePaymentLineView {
  vehicleId: string;
  chassisNo: string;
  customerName: string | null;
  amount: number;
  shortfall: number;
}

export interface FinancePaymentView {
  id: string;
  utr: string;
  financier: string | null;
  amount: number;
  receivedOn: string;
  note: string | null;
  recordedBy: string | null;
  createdAt: string;
  lines: FinancePaymentLineView[];
}

export interface FinancePendingResponse {
  rows: FinancePendingRow[];
  /** Pending by financier, biggest first — the ones to chase. */
  byFinancier: Array<{ key: string; financierId: string | null; financier: string; vehicles: number; remaining: number }>;
  totalRemaining: number;
}
